<template>
  <div class="main">
    <Header
      :show="true"
      title="添加车辆"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c"
        background="#FFFBE8"
        text="注意：车辆名称不能跟现有的名称一样"
      />
      <van-form
        ref="create"
        @submit="submit"
      >
        <van-field
          v-model.trim="listQuery.plateNumber"
          label="车牌号"
          placeholder="请输入车牌号"
          required
          :rules="[{ validator: validCheckPlateNumber, message: '' }]"
        />
        <van-field
          clickable
          name="picker"
          :value="listQuery.type"
          label="车辆类别"
          placeholder="选择车辆类别"
          required
          :rules="[{ validator: validCheckName, message: '请选择车辆类别' }]"
          @click="type.show = true"
        />
        <van-popup
          v-model="type.show"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="type.columns"
            @confirm="handleTruckTypeSelect"
            @cancel="type.show = false"
          />
        </van-popup>
        <van-field
          v-model.trim="listQuery.driver"
          label="司机"
          placeholder="请输入司机名称"
          :rules="[
            { validator: validName, message: '司机名称长度应在 2-20 位，仅支持中文' },
          ]"
        />
        <van-field
          v-model.trim="listQuery.phone"
          label="手机号码"
          placeholder="请输入司机手机号码"
          :rules="[{ validator: validPhone, message: '手机号格式错误' }]"
        />
        <van-field
          v-model.trim="listQuery.remark"
          rows="2"
          autosize
          label="说明"
          type="textarea"
          maxlength="100"
          placeholder="请输入车辆说明"
          show-word-limit
        />
        <div
          v-if="checkPermission([172])"
          style="margin: 0.6rem 1rem"
        >
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import {
  isPlateNumber,
  isUserName,
  isPassword,
  isChinese,
  isPhone,
  isEmail,
  isNumberFloat,
} from "@/utils/validate.js";
import { createOne } from "@/api/truck.js";

export default {
  name: "ServiceSystemTruckCreate",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      isLoading: false,
      loading: false,
      listQuery: {
        plateNumber: "",
        type: "固定车辆",
        size: "小型车辆",
        tareWeight: "",
        loadCapacity: "",
        driver: "",
        phone: "",
        remark: "",
      },
      type: {
        show: false,
        columns: ["固定车辆"],
      },
      size: {
        show: false,
        columns: ["小型车辆"],
      },
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
      // console.log('dashboard-left')
    },
    handleClickRight() {
      this.$refs.create.submit();
    },
    submit() {
      Dialog.confirm({
        title: "确认新增车辆？",
        message: "车牌号：" + this.listQuery.plateNumber,
      })
        .then(() => {
          this.loading = true;
          const data = {
            plateNumber: this.listQuery.plateNumber,
            type: this.listQuery.type,
            truckType: this.listQuery.size,
            tareWeight: this.listQuery.tareWeight,
            loadCapacity: this.listQuery.loadCapacity,
            driver: this.listQuery.driver,
            phone: this.listQuery.phone,
            remark: this.listQuery.remark,
          };
          createOne(data)
            .then((response) => {
              const { data } = response;
              if (
                showPhoneAlarm(
                  true,
                  "toast",
                  null,
                  2000,
                  data.code,
                  "新增车辆",
                  data.message
                )
              ) {
                this.$router.push({ path: "/service/system/truck", query: {} });
              }
              this.loading = false;
            })
            .catch(function (error) {
              this.loading = false;
              console.error(error);
            });
        })
        .catch(() => {
          showPhoneAlarm(
            true,
            "toast",
            "success",
            2000,
            200,
            "新增车辆",
            "取消"
          );
        });
    },
    validNumberFloat(value) {
      return new Promise((resolve) => {
        const result = isNumberFloat(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    validName(value) {
      return new Promise((resolve) => {
        if (!value) resolve(true);
        const result = isChinese(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    validPhone(value) {
      return new Promise((resolve) => {
        if (!value) resolve(true);
        const result = isPhone(value, 11, 11);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    validPlateNumber(value) {
      return new Promise((resolve) => {
        const result = isPlateNumber(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          showPhoneAlarm(true, "toast", null, 2000, null, result, null);
          resolve(false);
        }
      });
    },
    handleTruckSizeSelect(value) {
      this.listQuery.size = value;
      this.size.show = false;
    },
    handleTruckTypeSelect(value) {
      this.listQuery.type = value;
      this.type.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
